import { render } from "./AngolaPage.vue?vue&type=template&id=516a9684&scoped=true"
import script from "./AngolaPage.vue?vue&type=script&lang=js"
export * from "./AngolaPage.vue?vue&type=script&lang=js"

import "./AngolaPage.vue?vue&type=style&index=0&id=516a9684&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516a9684"]])

export default __exports__